import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { restrictInputToAlphabet } from 'src/services/core/helper/helper';
import { Logger } from 'src/services/core/logger/logger.service';

const log = new Logger('Pin');

@Component({
  selector: 'app-base-pin-input',
  templateUrl: './base-pin-input.component.html',
  styleUrls: ['./base-pin-input.component.scss'],
})
export class BasePinInputComponent {
  @ViewChild('pinInput1') pinInput1!: ElementRef;
  @ViewChild('pinInput2') pinInput2!: ElementRef;
  @ViewChild('pinInput3') pinInput3!: ElementRef;
  @ViewChild('pinInput4') pinInput4!: ElementRef;

  @Input() indexValue!: number;
  @Output() pinComplete = new EventEmitter();

  pinValue1 = '';
  pinValue2 = '';
  pinValue3 = '';
  pinValue4 = '';
  proceed = false;

  formatPinInput(event: any) {
    const charCode = event?.which ? event?.which : event?.keyCode;
    this.proceed = restrictInputToAlphabet(charCode, event);
    if (this.proceed && charCode !== 8 && event.target.value.length >= 1) {
      event.preventDefault();
    }
  }

  checkFocusability(event: any, valueIndex: number) {
    const charCode = event?.which ? event?.which : event?.keyCode;

    if (this.proceed) {
      if (charCode !== 8 && valueIndex < 5) {
        switch (valueIndex) {
          case 2:
            setTimeout(() => this.pinInput2.nativeElement.focus(), 0);
            break;

          case 3:
            setTimeout(() => this.pinInput3.nativeElement.focus(), 0);
            break;

          case 4:
            setTimeout(() => this.pinInput4.nativeElement.focus(), 0);
            break;

          // default:
          //   break;
        }
      }
      // else {
      //   if (valueIndex > 2 && charCode === 8) {
      //     setTimeout(() => this.pinInput1.nativeElement.focus(), 0);
      //   }
      // }
    }

    this.checkPinCompletion();
  }

  checkPinCompletion() {
    let completePin = `${this.pinValue1}${this.pinValue2}${this.pinValue3}${this.pinValue4}`;

    if (completePin.length === 4) {
      setTimeout(() => this.pinInput4.nativeElement.blur(), 0);

      this.pinComplete.emit(completePin);
    }
  }
}
